import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
//import arRows from "ar-rows";
import { gsap, random } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import zenscroll from "zenscroll";

gsap.registerPlugin(ScrollTrigger, SplitText);

/* SETUP VARS */
let bw = document.body.scrollWidth;
let isMobile = false;
if (bw <= 1023 && document.body.scrollWidth < document.body.scrollHeight) {
  isMobile = true;
}
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const header = document.querySelector("header");
const contentEl = document.getElementById("content");
let outsideContentEls = document.querySelectorAll(".needsblur");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayContent = overlay.querySelector(".content");

window.addEventListener("load", (event) => {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // check for fixed page text and move out of article flow
  let pageTextFixedEl = document.querySelector(".pageText_fixed");
  if (typeof pageTextFixedEl != "undefined" && pageTextFixedEl != null) {
    body.append(pageTextFixedEl);
    pageTextFixedEl.classList.add("ready");
  }

  function loadInit() {
    // any cols from text editor need to be wrapped in cols class
    let textCols = document.querySelectorAll(".text-block");
    for (var i = 0; i < textCols.length; i++) {
      wrapCols(textCols[i]);
    }

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });

    body.classList.add("ready");
  }

  loadInit();

  // loose grids

  let looseGrids = document.querySelectorAll(".grid_loose");
  looseGrids.forEach((looseGrid) => {
    let catid = looseGrid.getAttribute("data-catid");
    let grid;
    let view = "desktop";
    let resizeTimeout;

    function checkView() {
      let newView = innerWidth <= 768 ? "mobile" : "desktop";
      if (view !== newView) {
        view = newView;
        return true;
      }
      return false;
    }

    function loadGrid() {
      fetch(`/getCanvas.php?catid=${catid}&view=${view}`)
        .then((response) => response.text())
        .then((data) => {
          looseGrid.innerHTML = data;
          grid = looseGrid.querySelector("ul.canvas");

          const resizeObserver = new ResizeObserver(updatePositions);
          resizeObserver.observe(grid);

          loadInit();

          setTimeout(function () {
            updateContainerHeight();
          }, 500);
        })
        .catch((error) => console.error("Error:", error));
    }

    // Initial check and load
    checkView();
    loadGrid();

    // Debounced window resize handler
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (checkView()) {
          loadGrid();
        }
      }, 250); // Wait 250ms after last resize event
    });

    function updatePositions() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      const { width, height } = grid.getBoundingClientRect();

      items.forEach((item) => {
        let percentX = parseFloat(item.dataset.x);
        let percentY = parseFloat(item.dataset.y);

        // apply the new positions as pixels
        item.style.left = `${(percentX / 100) * width}px`;
        item.style.top = `${(percentY / 100) * width}px`; // Base top on width

        // clear out transforms from draggable
        gsap.set(item, {
          x: 0,
          y: 0,
          z: 0,
        });
      });

      updateContainerHeight();
    }

    function updateContainerHeight() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      requestAnimationFrame(() => {
        let maxBottom = 0;

        items.forEach((item) => {
          let topPos = gsap.getProperty(item, "top"); // Get the top position in pixels
          itemBottom = topPos + item.offsetHeight; // Distance from top + height
          maxBottom = Math.max(maxBottom, itemBottom);
        });

        grid.style.height = `${Math.ceil(maxBottom)}px`; // Round up & add buffer for admin, on front-end this should be tight to the grid
        grid.style.minHeight = "auto";
      });
    }
  });

  // check for any hovervideo classes
  let hoverVideoEls = document.querySelectorAll(".hovervideo");
  hoverVideoEls.forEach((hoverVideoEl) => {
    hoverVideoEl.addEventListener("mouseenter", function () {
      playAutoVideo(hoverVideoEl);
    });
    hoverVideoEl.addEventListener("mouseleave", function () {
      pauseAutoVideo(hoverVideoEl);
    });
  });

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      if (videoEl.classList.contains("sizeload")) {
        sizeloadVideo(videoEl);
      }
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function sizeloadVideo(el) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
  }

  let sizeLoadVideoEls = document.querySelectorAll("video.sizeload");
  for (let i = 0; i < sizeLoadVideoEls.length; i++) {
    sizeloadVideo(sizeLoadVideoEls[i]);
  }

  if (body.classList.contains("projectpage")) {
    // need to call sizeLoad function for direct video URL
    let projectVideoEl = document.querySelector("video");
    sizeloadVideo(projectVideoEl);
    // CLOSE OVERLAY DIV
    let closerDiv = overlay.querySelector(".closer");
    if (typeof closerDiv != "undefined" && closerDiv != null) {
      closerDiv.addEventListener("click", closeOverlay);
    }
  }

  /*
  // initialize masonry
  const masongrid = document.getElementById("grid");

  if (typeof masongrid != "undefined" && masongrid != null) {
    //injecting bottom margin into masonry cell
    let gutterWidth = document.querySelector(".gutter-sizer").scrollWidth;
    let cells = masongrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masongrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  }
  */

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let slideshowPager = document.getElementById("slide-pager");
  let slideshowPagerItems, slideTimer, flkty, duration;
  if (typeof slideshowPager != "undefined" && slideshowPager != null) {
    slideshowPagerItems = slideshowPager.querySelectorAll(".item");
    for (let i = 0; i < slideshowPagerItems.length; ++i) {
      slideshowPagerItems[i].addEventListener("click", function (e) {
        e.preventDefault();
        let slideIndex = this.getAttribute("data-count");
        stopAutoSlideshow(slideIndex);
      });
    }
  }

  function stopAutoSlideshow(goto) {
    // stop the timer
    clearTimer();
    // go to selected slide
    gotoSlide(goto);
  }

  function revealTitle() {
    gsap.set(".titleChild", { y: 25, autoAlpha: 0 });
    let activeSlide = slideshowEl.querySelector(".is-selected"),
      activeCount = activeSlide.getAttribute("data-count"),
      slideDuration = activeSlide.getAttribute("data-duration"),
      slideTitle = activeSlide.querySelectorAll("h2.title .titleChild");

    duration = slideDuration * 1000 - 500;

    gsap.to(slideTitle, { autoAlpha: 1, y: 0, stagger: { each: 0.05 } });
    startTimer(duration);
  }

  function startTimer(duration) {
    slideTimer = setTimeout(nextSlide, duration);
  }

  function clearTimer() {
    clearTimeout(slideTimer);
  }

  function gotoSlide(slideCount) {
    // update active page
    for (let i = 0; i < slideshowPagerItems.length; ++i) {
      slideshowPagerItems[i].classList.remove("active");
    }

    slideshowPager
      .querySelector(".item[data-count='" + slideCount + "']")
      .classList.add("active");

    // check if slide we are jumping too has video content
    let nextSlide = slideshowEl.querySelector(
      ".cell[data-count='" + slideCount + "']"
    );
    let vidHold = nextSlide.querySelector(".vidhold");
    if (nextSlide.classList.contains("slidevideo")) {
      let videoStr = nextSlide.getAttribute("data-video");
      vidHold.innerHTML = videoStr;
    }

    // transition actual slide
    let slideIndex = slideCount - 1;
    flkty.selectCell(slideIndex, true, false);
  }

  function nextSlide() {
    let activeSlide = slideshowEl.querySelector(".is-selected"),
      activeCount = parseInt(activeSlide.getAttribute("data-count")) + 1;

    if (parseInt(activeCount) > parseInt(slideshowPagerItems.length)) {
      activeCount = 1;
    }

    let nextSlide = slideshowEl.querySelector(
      ".cell[data-count='" + activeCount + "']"
    );
    let vidHold = nextSlide.querySelector(".vidhold");
    if (nextSlide.classList.contains("slidevideo")) {
      let videoStr = nextSlide.getAttribute("data-video");
      vidHold.innerHTML = videoStr;
    }

    for (let i = 0; i < slideshowPagerItems.length; ++i) {
      slideshowPagerItems[i].classList.remove("active");
    }

    slideshowPager
      .querySelector(".item[data-count='" + activeCount + "']")
      .classList.add("active");
    flkty.next();
  }

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      wrapAround: true,
      on: {
        ready: function () {
          // split text all slide titles
          let slideTitles = slideshowEl.querySelectorAll("h2.title");
          new SplitText(slideTitles, {
            type: "words",
            wordsClass: "titleParent",
          });
          new SplitText(slideTitles, {
            type: "words",
            wordsClass: "titleChild",
          });

          gsap.set(".titleChild", { y: 25, autoAlpha: 0 });

          // if first slide has video load that to dom
          let activeSlide = slideshowEl.querySelector(".is-selected");
          let vidHold = activeSlide.querySelector(".vidhold");
          if (activeSlide.classList.contains("slidevideo")) {
            let videoStr = activeSlide.getAttribute("data-video");
            vidHold.innerHTML = videoStr;
          }
        },
      },
    });

    // change event
    flkty.on("change", function (index) {
      setTimeout(function () {
        revealTitle();
      }, 500);
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/" + img;
      /*
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        console.log(fullpath);
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullpath;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
      */
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  function toggleDirectors(el) {
    let rsList = false;
    let smList = false;
    if (el.classList.contains("rs_trigger")) {
      rsList = true;
    } else if (el.classList.contains("shipmates_trigger")) {
      smList = true;
    }

    let navListItems = nav.querySelectorAll("ul li");
    navListItems.forEach((navListItem) => {
      navListItem.classList.remove("menuOpen");
    });

    // remove the shipmates text
    let pageText = document.querySelector(".pageText_fixed");
    if (typeof pageText != "undefined" && pageText != null) {
      pageText.classList.remove("ready");
      setTimeout(function () {
        pageText.parentNode.removeChild(pageText);
      }, 300);
    }

    if (el.parentNode.classList.contains("menuOpen")) {
      // close everything
      closeDirectors();
      closeRS();
      closeSM();

      if (rsList) {
        rsDirectorList.classList.remove("open");
        gsap.set("#rs_list .directorChild", { y: 25, autoAlpha: 0 });
      } else if (smList) {
        smDirectorList.classList.remove("open");
        gsap.set("#shipmates_list .directorChild", { y: 25, autoAlpha: 0 });
      } else {
        directorList.classList.remove("open");
        //directorFilter.querySelector("li a[data-filter='all']").classList.remove("pageOn");
        gsap.set("#director_list .directorChild", { y: 25, autoAlpha: 0 });
      }
      directorBg.classList.remove("open");
    } else {
      // open selected
      body.classList.add("fixed_nav_open");
      el.parentNode.classList.add("menuOpen");
      if (rsList) {
        closeDirectors();
        closeSM();
        rsDirectorList.classList.add("open");
        gsap.to("#rs_list .directorChild", {
          autoAlpha: 1,
          y: 0,
          stagger: { each: 0.03 },
        });
      } else if (smList) {
        closeDirectors();
        closeRS();
        smDirectorList.classList.add("open");
        gsap.to("#shipmates_list .directorChild", {
          autoAlpha: 1,
          y: 0,
          stagger: { each: 0.03 },
        });
        // show the shipmates text
        getAjax("/getShipmatesText.php", function (data) {
          let results = JSON.parse(data);
          let div = document.createElement("div");
          div.classList.add("pageText_fixed");
          div.classList.add("ready");
          div.innerHTML = results;
          body.append(div);
        });
      } else {
        closeRS();
        closeSM();
        gsap.to("#director_list .directorChild", {
          autoAlpha: 1,
          y: 0,
          stagger: { each: 0.03 },
        });
        directorList.classList.add("open");
      }

      directorBg.classList.add("open");
      /*
      // assign pageOn class to ALL country filter.  Delayed here show it appears after stagger animation
      setTimeout(function() {
        if (!rsList) {
          directorFilter.querySelector("li a[data-filter='all']").classList.add("pageOn");
        }        
      }, 500);
      */
    }
  }

  function openDirectors() {
    gsap.to(".directorChild", {
      autoAlpha: 1,
      y: 0,
      stagger: { each: 0.03 },
    });
    nav.querySelector("ul li").classList.add("menuOpen");
    directorList.classList.add("open");
    directorBg.classList.add("open");
    /*
    // assign pageOn class to ALL country filter.  Delayed here show it appears after stagger animation
    setTimeout(function() {
      directorFilter.querySelector("li a[data-filter='all']").classList.add("pageOn");
    }, 500);
    */
  }

  function closeDirectors() {
    gsap.to("#director_list .directorChild", {
      autoAlpha: 0,
      y: -25,
      stagger: { each: 0.03 },
    });
    directorList.classList.remove("open");
    directorBg.classList.remove("open");
    body.classList.remove("fixed_nav_open");
    //directorFilter.querySelector("li a[data-filter='all']").classList.remove("pageOn");
  }

  function closeRS() {
    gsap.to("#rs_list .directorChild", {
      autoAlpha: 0,
      y: -25,
      stagger: { each: 0.03 },
    });
    rsDirectorList.classList.remove("open");
    directorBg.classList.remove("open");
  }

  function closeSM() {
    gsap.to("#shipmates_list .directorChild", {
      autoAlpha: 0,
      y: -25,
      stagger: { each: 0.03 },
    });
    smDirectorList.classList.remove("open");
    directorBg.classList.remove("open");
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    mobileLogoInit();
    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  function resetNav() {
    // this is used to close any open panels and close icons
    let navItems = nav.querySelectorAll("ul li");
    let navItemsLength = navItems.length;
    for (let i = 0; i < navItemsLength; ++i) {
      navItems[i].classList.remove("menuOpen");
      let navLink = navItems[i].querySelector("a");
      navLink.classList.remove("hide");
    }
  }

  function openOverlay(bg) {
    if (bg === "transparent") {
      overlay.classList.add("transparent");
    }
    overlay.classList.add("on");

    // CLOSE OVERLAY DIV
    let closerDiv = overlay.querySelector(".closer");
    if (typeof closerDiv != "undefined" && closerDiv != null) {
      closerDiv.addEventListener("click", closeOverlay);
    }

    // DIRECTOR LINK IN OVERLAY ACTS AS NORMAL LINK OR OVERLAY CLOSER DEPENDING ON PAGE PARENT.
    let directorLink = overlay.querySelector("a.directorLink");
    if (typeof directorLink != "undefined" && directorLink != null) {
      let directorPageCheck = document.querySelector(".inner.director");
      if (
        typeof directorPageCheck != "undefined" &&
        directorPageCheck != null
      ) {
        // came from director page, just close overlay
        directorLink.addEventListener("click", function (e) {
          e.preventDefault();
          closeOverlay();
        });
      }
    }
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    body.classList.remove("blur");
    body.classList.remove("overlay_open");
    resetNav();
    overlayContent.innerHTML = "";
    setTimeout(function () {
      overlay.classList.remove("transparent");
    }, 500);
  }

  function videoPlayer(id, catid) {
    getAjax("/getVideo.php?id=" + id + "&catid=" + catid, function (data) {
      // load data into overlay
      overlayContent.innerHTML = data;

      // get video and start playback
      let videoEl = overlay.querySelector("video");
      if (typeof videoEl != "undefined" && videoEl != null) {
        sizeloadVideo(videoEl);
        videoEl.play();
        videoEl.addEventListener("canplaythrough", (event) => {
          overlayContent.querySelector(".wrap").classList.add("ready");
          //videoEl.classList.add("ready");
        });
      }

      // open overlay
      openOverlay("solid");
    });
  }

  function textOverlay(slug, el) {
    // TODO - UPDATE URL WITH SLUG

    // close the director list
    closeDirectors();
    closeRS();
    closeSM();

    /*
    // hide all menu items except selected
    let navLinks = nav.querySelectorAll("ul li a");
    let navLinksLength = navLinks.length;
    for (let i = 0; i < navLinksLength; ++i) {
      let linkSlug = navLinks[i].getAttribute("data-slug");
      if (linkSlug !== slug) {
        navLinks[i].classList.add("hide");
      }
    }
    */

    el.parentNode.classList.add("menuOpen");
    getAjax("/getTextPage.php?slug=" + slug, function (data) {
      // load data into overlay
      overlayContent.innerHTML = data;
      let overlayTextBlock = overlay.querySelector(".text-block");

      wrapCols(overlayTextBlock);

      // open overlay
      body.classList.add("overlay_open");
      body.classList.remove("menuOn");
      openOverlay("transparent");
      mobileLogoInit();
    });
  }

  function rosterInit() {
    let rosterLinkUL = document.querySelector(".roster_list ul");
    let rosterLinkLIs = rosterLinkUL.querySelectorAll("li");
    let rosterLinkEls = document.querySelectorAll(".roster_list a");

    // hide the list items by default for stagger reveal
    gsap.set(rosterLinkLIs, { y: 25, autoAlpha: 0 });

    setTimeout(function () {
      // stagger on the list items
      gsap.to(rosterLinkLIs, {
        autoAlpha: 1,
        y: 0,
        stagger: { each: 0.1 },
      });
    }, 200);

    // hovering anywhere over roster list triggers background
    rosterLinkUL.addEventListener("mouseenter", function () {
      document.querySelector(".roster_list #background").style.opacity = 1;
    });
    rosterLinkUL.addEventListener("mouseleave", function () {
      document.querySelector(".roster_list #background").style.opacity = 0;
    });

    // hovering over individual links triggers images and active state
    rosterLinkEls.forEach((rosterLinkEl) => {
      rosterLinkEl.addEventListener("mouseenter", function () {
        let rosterId = rosterLinkEl.getAttribute("data-id");
        let targetRow = document.querySelector(
          ".roster_list .media .row[data-id='" + rosterId + "']"
        );
        targetRow.classList.add("active");
      });
      rosterLinkEl.addEventListener("mouseleave", function () {
        let rosterId = rosterLinkEl.getAttribute("data-id");
        let targetRow = document.querySelector(
          ".roster_list .media .row[data-id='" + rosterId + "']"
        );
        targetRow.classList.remove("active");
      });
    });
  }

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  setTimeout(function () {
    const contactPageLooseItems = document.querySelectorAll(
      ".textpage .grid_loose .cell .mediawrap"
    );
    const maxVisibleItems = 5;
    const totalItems = contactPageLooseItems.length;
    const timeline = gsap.timeline();

    // Hide all items initially
    gsap.set(contactPageLooseItems, { autoAlpha: 0, y: 30 });

    // Create an array to track which items are currently visible
    const visibleItems = new Array(totalItems).fill(false);

    function updateAnimation() {
      // Count current visible items
      const currentVisibleCount = visibleItems.filter((item) => item).length;

      // Determine how many items we need to show or hide
      let itemsToShow =
        Math.min(maxVisibleItems, totalItems) - currentVisibleCount;

      if (itemsToShow > 0) {
        // Show random hidden items
        for (let i = 0; i < itemsToShow; i++) {
          // Find hidden items
          const hiddenIndices = visibleItems
            .map((visible, index) => ({ visible, index }))
            .filter((item) => !item.visible)
            .map((item) => item.index);

          if (hiddenIndices.length > 0) {
            const randomHiddenIndex =
              hiddenIndices[Math.floor(Math.random() * hiddenIndices.length)];
            visibleItems[randomHiddenIndex] = true;

            // Animate item appearing
            timeline.to(
              contactPageLooseItems[randomHiddenIndex],
              {
                autoAlpha: 1,
                y: 0,
                duration: gsap.utils.random(1, 2),
                ease: "linear",
              },
              ">"
            );
          }
        }
      } else {
        // We have too many visible items or just the right amount
        // If we have the right amount, still cycle items for visual interest
        const visibleIndices = visibleItems
          .map((visible, index) => ({ visible, index }))
          .filter((item) => item.visible)
          .map((item) => item.index);

        if (visibleIndices.length > 0) {
          const randomVisibleIndex =
            visibleIndices[Math.floor(Math.random() * visibleIndices.length)];
          visibleItems[randomVisibleIndex] = false;

          // Animate item disappearing
          timeline
            .to(
              contactPageLooseItems[randomVisibleIndex],
              {
                autoAlpha: 0,
                duration: gsap.utils.random(1, 2),
                ease: "linear",
              },
              ">"
            )
            .to(contactPageLooseItems[randomVisibleIndex], {
              y: 30,
              duration: 0,
              ease: "linear",
            });
        }
      }

      // Schedule next update
      gsap.delayedCall(gsap.utils.random(1.5, 3), updateAnimation);
    }

    // Start the animation cycle
    updateAnimation();
  }, 500);

  // contact page images are going to fade in and out
  let contactPageItemsOne = document.querySelectorAll(
    ".textpage .item_1 .mediawrap"
  );
  let contactPageItemsTwo = document.querySelectorAll(
    ".textpage .item_2 .mediawrap"
  );
  let contactPageItemsThree = document.querySelectorAll(
    ".textpage .item_3 .mediawrap"
  );

  // Contact page image animations
  if (contactPageItemsOne.length > 0) {
    // Hide all items initially except the first one
    gsap.set(contactPageItemsOne, {
      opacity: 0,
      y: 50,
      x: gsap.utils.random(-30, innerWidth * 0.8, 10),
    });

    // Create timeline for first group
    let tl1 = gsap.timeline({
      repeat: -1,
    });

    // Add animations for each item
    contactPageItemsOne.forEach((item, index) => {
      let nextIndex = (index + 1) % contactPageItemsOne.length;

      tl1
        // Step 1: Fade in and float up
        .to(item, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 2,
        })
        // Step 2: Stay visible for 2 seconds
        .to(item, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: gsap.utils.random(2, 4, 0.1),
        })
        // Step 3: Float up and fade out
        .to(item, {
          opacity: 0,
          y: -50,
          scale: 0.95,
          duration: gsap.utils.random(1, 2, 0.1),
        })
        // Set next item to starting position
        .set(contactPageItemsOne[nextIndex], {
          opacity: 0,
          y: 50,
          x: gsap.utils.random(-30, innerWidth * 0.8, 10),
          scale: 1,
        });
    });
  }

  // Do the same for other groups
  if (contactPageItemsTwo.length > 0) {
    gsap.set(contactPageItemsTwo, {
      opacity: 0,
      y: 50,
      x: gsap.utils.random(-30, innerWidth * 0.7, 10),
    });

    let tl2 = gsap.timeline({
      repeat: -1,
      delay: 1,
    });

    contactPageItemsTwo.forEach((item, index) => {
      let nextIndex = (index + 1) % contactPageItemsTwo.length;

      tl2
        // Step 1: Fade in and float up
        .to(item, {
          opacity: 1,
          y: 0,
          duration: 1.5,
        })
        // Step 2: Stay visible for 2 seconds
        .to(item, {
          opacity: 1,
          y: 0,
          duration: gsap.utils.random(2, 4, 0.1),
        })
        // Step 3: Float up and fade out
        .to(item, {
          opacity: 0,
          y: -50,
          scale: 0.95,
          duration: gsap.utils.random(1, 2, 0.1),
        })
        // Set next item to starting position
        .set(contactPageItemsTwo[nextIndex], {
          opacity: 0,
          y: 50,
          x: gsap.utils.random(-30, innerWidth * 0.7, 10),
        });
    });
  }

  if (contactPageItemsThree.length > 0) {
    gsap.set(contactPageItemsThree, {
      opacity: 0,
      y: 50,
      x: gsap.utils.random(innerWidth * 0.4 * -1, 0, 10),
    });

    let tl3 = gsap.timeline({
      repeat: -1,
      delay: 0.5,
    });

    contactPageItemsThree.forEach((item, index) => {
      let nextIndex = (index + 1) % contactPageItemsThree.length;

      tl3
        // Step 1: Fade in and float up
        .to(item, {
          opacity: 1,
          y: 0,
          duration: 2,
        })
        // Step 2: Stay visible for 2 seconds
        .to(item, {
          opacity: 1,
          y: 0,
          duration: gsap.utils.random(2, 4, 0.1),
        })
        // Step 3: Float up and fade out
        .to(item, {
          opacity: 0,
          y: -50,
          duration: gsap.utils.random(1, 2, 0.1),
        })
        // Set next item to starting position
        .set(contactPageItemsThree[nextIndex], {
          opacity: 0,
          y: 50,
          x: gsap.utils.random(innerWidth * 0.4 * -1, 0, 10),
        });
    });
  }

  // 2025 roster bio functions

  function bioInit() {
    // scroll to Link
    let bioScrollLink = document.querySelector(".bio_link");
    if (typeof bioScrollLink != "undefined" && bioScrollLink != null) {
      bioScrollLink.addEventListener("click", function (e) {
        e.preventDefault();
        zenscroll.to(document.querySelector(".bio"));
      });
    }

    // convert bio text social links to icons
    let bioText = document.querySelectorAll(".bio");
    if (typeof bioText != "undefined" && bioText != null) {
      socialIcons(bioText);
    }
  }

  bioInit();

  // roster list hover events
  let rosterListEl = document.querySelector(".roster_list");
  if (typeof rosterListEl != "undefined" && rosterListEl != null) {
    rosterInit();
  }

  // UPDATE DIRECTION SOCIAL LINKS TO ICONS
  let loadDirectorBio = document.getElementById("director_bio");
  if (typeof loadDirectorBio != "undefined" && loadDirectorBio != null) {
    let directorText = loadDirectorBio.querySelectorAll(".textwrap");
    let directorMobileText = document.querySelectorAll(
      ".director_bio_mobile .textwrap"
    );
    socialIcons(directorText);
    socialIcons(directorMobileText);
  }

  let headerLogo = header.querySelector(".logo");
  let headerLogoImg = header.querySelector(".logo svg");
  // ON SCROLL, FADE OUT LOGO SO IT DOESN'T INTERFERE WITH CONTENT
  function headerLogoInit() {
    let headerOpacity = 0.3;
    let headerTop = "100px";
    if (bw <= 1023 && document.body.scrollWidth < document.body.scrollHeight) {
      headerOpacity = 0;
      headerTop = "50px";
    }
    const headerLogoTl = gsap.timeline({
      scrollTrigger: {
        trigger: headerLogo, //this is the element that will trigger the animation
        start: "top top", //this string defines the trigger and scroller start
        end: headerTop, //this string defines the trigger and scroller end
        scrub: 1, //this tells GSAP to link animation progress to scroll progress
        markers: false,
      },
    });
    headerLogoTl.to(headerLogo, {
      opacity: headerOpacity,
    });
  }
  headerLogoInit();

  // FIXED POSITION PAGES LIKE ABOUT AND CONTACT NEED HIDDEN LOGO ON SCROLL
  function mobileLogoInit() {
    if (bw <= 1023 && document.body.scrollWidth < window.innerHeight) {
      let mobileLogoCheck = document.querySelector(".hidemobilelogo");
      if (typeof mobileLogoCheck != "undefined" && mobileLogoCheck != null) {
        let fixedContainer = document.querySelectorAll(
          ".hidemobilelogo .thescroller"
        );

        // SCROLL ==================================
        for (let i = 0; i < fixedContainer.length; ++i) {
          fixedContainer[i].addEventListener(
            "scroll",
            function () {
              var st = fixedContainer[i].scrollTop;
              if (st > 25) {
                headerLogoImg.classList.add("hide");
              } else {
                headerLogoImg.classList.remove("hide");
              }
            },
            false
          );
        }
      }
    }
  }
  mobileLogoInit();

  // IF DIRECTOR PAGE, MOVE BIO OUTSIDE OF CONTENT
  // move director bio out of article, after header
  let newBio = contentEl.querySelector("#director_bio");
  if (typeof newBio != "undefined" && newBio != null) {
    header.after(newBio);
    newBio.classList.remove("fadeout");
  }

  function mobileBioInit() {
    let mobileBioLink = document.querySelector("a.bioLink");
    if (typeof mobileBioLink != "undefined" && mobileBioLink != null) {
      mobileBioLink.addEventListener("click", function (e) {
        e.preventDefault();
        const offsetTop = document.getElementById("bio_mobile").offsetTop;

        scroll({
          top: offsetTop,
          behavior: "smooth",
        });
      });
    }
  }
  mobileBioInit();

  // PUSH STATE LOADING =======================================

  window.addEventListener("popstate", function () {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    if (overlay.classList.contains("on")) {
      closeOverlay();
      return;
    }
    if (location.pathname === "/") {
      window.location.href = "/";
    } else {
      loadContent(location.pathname);
    }
  });

  function ajaxClick(event) {
    event.preventDefault();
    let page = this.getAttribute("href");
    loadContent(page);
    history.pushState("", "New URL: " + page, page);
  }

  let ajaxLinks = document.querySelectorAll("a.ajaxLink");
  let overlayLinks = document.querySelectorAll("a.overlay_trigger");
  function ajaxLinksInit() {
    ajaxLinks.forEach((ajaxLink) => {
      ajaxLink.removeEventListener("click", ajaxClick);
      ajaxLink.addEventListener("click", ajaxClick);
    });
  }
  ajaxLinksInit();

  function removeLinkState() {
    ajaxLinks.forEach((ajaxLink) => {
      ajaxLink.classList.remove("pageOn");
    });
    overlayLinks.forEach((overlayLink) => {
      overlayLink.classList.remove("pageOn");
    });
  }

  function loadContent(url) {
    // close any open overlays
    overlay.classList.remove("on");

    // remove fixed page text
    let pageTextFixedEl = document.querySelector(".pageText_fixed");
    if (typeof pageTextFixedEl != "undefined" && pageTextFixedEl != null) {
      pageTextFixedEl.classList.remove("ready");
      setTimeout(function () {
        pageTextFixedEl.parentNode.removeChild(pageTextFixedEl);
      }, 510);
    }

    // remove media bg
    removeActiveMedia();

    // remove on state from menu links, apply pageOn to selected based on matched url
    removeLinkState();
    body.classList.remove(
      "menuOn",
      "ready",
      "projectpage",
      "blur",
      "overlay_open"
    );

    let slug = url.replace("/", "");
    let activeLink = document.querySelector(
      'a.ajaxLink[data-slug="' + slug + '"]'
    );
    if (typeof activeLink != "undefined" && activeLink != null) {
      activeLink.classList.add("pageOn");
    }

    // need to redefine els outside content for dynamic content
    let outsideContentEls = document.querySelectorAll(".needsblur");

    // fade out main content el and any fixed position elements
    contentEl.classList.add("fadeout");
    outsideContentEls.forEach((outsideContentEl) => {
      outsideContentEl.classList.add("fadeout");
    });
    // close the director list
    setTimeout(function () {
      closeDirectors();
      closeRS();
      closeSM();
    }, 300);

    // ajax call to get new content
    getAjax("/content.php?page=" + url, function (data) {
      window.scroll(0, 0);
      // wait for content to fade out before loading new content
      let newBio;
      setTimeout(function () {
        // remove director_bio id from dom, will replace below
        let oldBio = document.getElementById("director_bio");
        if (typeof oldBio != "undefined" && oldBio != null) {
          oldBio.parentNode.removeChild(oldBio);
        }
        contentEl.innerHTML = data;
        // move director bio out of article, after header
        newBio = contentEl.querySelector("#director_bio");
        if (typeof newBio != "undefined" && newBio != null) {
          header.after(newBio);
          let directorText = newBio.querySelectorAll(".textwrap");
          let directorTextMobile = document.querySelectorAll(
            ".director_bio_mobile .textwrap"
          );
          socialIcons(directorText);
          socialIcons(directorTextMobile);
        }
        loadInit();
        videoLinksInit();
        animateGridInit();
        headerLogoInit();
        mobileLogoInit();
        // roster functions
        let rosterListEl = document.querySelector(".roster_list");
        if (typeof rosterListEl != "undefined" && rosterListEl != null) {
          rosterInit();
        }
        // check for fixed page text and move out of article flow
        let pageTextFixedEl = document.querySelector(".pageText_fixed");
        if (typeof pageTextFixedEl != "undefined" && pageTextFixedEl != null) {
          body.append(pageTextFixedEl);
          pageTextFixedEl.classList.add("ready");
        }
      }, 500);

      // fade in new elements
      setTimeout(function () {
        contentEl.classList.remove("fadeout");
        if (typeof newBio != "undefined" && newBio != null) {
          newBio.classList.remove("fadeout");
          directorTitlesInit();
          mobileBioInit();
        }
        outsideContentEls.forEach((outsideContentEl) => {
          outsideContentEl.classList.remove("fadeout");
        });
        body.classList.add("ready");
      }, 1000);
    });
  }

  // SPLIT TEXT REVEAL - DIRECTOR LIST
  let directorItems = document.querySelectorAll("#director_list ul li a");
  let rsItems = document.querySelectorAll("#rs_list ul li a");
  let shipmatesItems = document.querySelectorAll("#shipmates_list ul li a");

  new SplitText(directorItems, {
    type: "words",
    wordsClass: "directorParent",
  });
  new SplitText(directorItems, {
    type: "words",
    wordsClass: "directorChild",
  });

  new SplitText(rsItems, {
    type: "words",
    wordsClass: "directorParent",
  });
  new SplitText(rsItems, {
    type: "words",
    wordsClass: "directorChild",
  });

  new SplitText(shipmatesItems, {
    type: "words",
    wordsClass: "directorParent",
  });
  new SplitText(shipmatesItems, {
    type: "words",
    wordsClass: "directorChild",
  });
  // this sets the default for animation, actual animation is below in scroller Callback
  gsap.set(".directorChild", { y: 25, autoAlpha: 0 });

  // SPLIT TEXT REVEAL - INTRO TEXT
  const intro = document.querySelector(".home #about");
  const blueCover = document.getElementById("blue-cover");
  let introHeadline = document.querySelector(".home #about h1");
  if (typeof introHeadline != "undefined" && introHeadline != null) {
    new SplitText(introHeadline, {
      type: "words",
      wordsClass: "wordParent",
    });
    new SplitText(introHeadline, {
      type: "words",
      wordsClass: "wordChild",
    });

    // this sets the default for animation, actual animation is below in scroller Callback
    gsap.set(".wordChild", { y: 25, autoAlpha: 0 });
    intro.classList.remove("loading");

    setTimeout(function () {
      ScrollTrigger.batch(".wordChild", {
        onEnter: (batch) =>
          gsap.to(batch, {
            autoAlpha: 1,
            y: 0,
            stagger: { each: 0.05 },
          }),
      });
    }, 250);

    // after text reveal hide the entire intro div
    setTimeout(function () {
      intro.classList.add("remove");
      gsap.to("#about .wordChild", {
        autoAlpha: 0,
        y: -25,
        stagger: { each: 0.03 },
      });
    }, 4500);
    setTimeout(function () {
      blueCover.classList.add("remove");
      // this shows the first slide title
      slideshowEl.classList.remove("loading");
      slideshowPager
        .querySelector(".item[data-count='1']")
        .classList.add("active");
      revealTitle();
    }, 5000);
  }

  function directorTitlesInit() {
    // REVEAL VIDEO TITLES ON DIRECTOR PAGE SCROLL
    let videoTitles = document.querySelectorAll(".director .cell h2");
    let videoTitlesLength = videoTitles.length;
    for (let i = 0; i < videoTitlesLength; ++i) {
      new SplitText(videoTitles[i], {
        type: "words",
        wordsClass: "titlesParent",
      });
      new SplitText(videoTitles[i], {
        type: "words",
        wordsClass: "titlesChild",
      });
    }

    // this sets the default for animation, actual animation is below in scroller Callback
    gsap.set(".titlesChild", { y: 25, autoAlpha: 0 });

    let titleAnimation = ScrollTrigger.batch(".titlesChild", {
      start: "top bottom",
      markers: false,
      onEnter: (batch) =>
        gsap.to(batch, { autoAlpha: 1, y: 0, stagger: { each: 0.05 } }),
    });
  }
  directorTitlesInit();

  // OVERLAY VIDEO PLAYER CLICKS
  function videoLinksInit() {
    let overlayLinks = document.querySelectorAll("a.videoPlayer");
    let overlayLinksLength = overlayLinks.length;
    for (let i = 0; i < overlayLinksLength; ++i) {
      overlayLinks[i].addEventListener("click", function (e) {
        e.preventDefault();
        let projectId = this.getAttribute("data-id");
        let catId = this.getAttribute("data-catid");
        let videoSlug = this.getAttribute("href");
        history.pushState("", "New URL: " + videoSlug, videoSlug);
        videoPlayer(projectId, catId);
      });
    }
  }

  videoLinksInit();

  // ANIMATED GRID AUTO GSAP SCROLL
  function animateGridInit() {
    const animateGrid = document.getElementById("animate_grid");
    if (typeof animateGrid != "undefined" && animateGrid != null) {
      const scroller = animateGrid.querySelector(".scroller");
      const cells = animateGrid.querySelectorAll(".cell");
      const cellsLength = cells.length;
      const containerHeight = scroller.offsetHeight;
      //scroller.style.height = containerHeight + "px";

      // speed is based on number of cells and the cell size
      let largeSpeed = cellsLength / 0.1;
      let smallSpeed = cellsLength / 0.05;

      cells.forEach((cell) => {
        const topBounds = -(cell.offsetHeight + cell.offsetTop);
        const wrapFunc = gsap.utils.unitize(
          gsap.utils.wrap(topBounds, containerHeight + topBounds)
        );

        if (cell.classList.contains("large")) {
          let yAmt = -containerHeight;
          gsap.to(cell, {
            y: yAmt,
            ease: "none",
            delay: 0.5,
            duration: largeSpeed,
            repeat: -1,
            modifiers: {
              y: wrapFunc,
            },
          });
        } else {
          let yAmt = containerHeight;
          gsap.to(cell, {
            y: yAmt,
            ease: "none",
            delay: 0.5,
            duration: smallSpeed,
            repeat: -1,
            modifiers: {
              y: wrapFunc,
            },
          });
        }
      });

      setTimeout(function () {
        animateGrid.classList.add("on");
      }, 300);
    }
  }
  animateGridInit();

  // SPLASH PAGE SPLIT TEXT REVEAL

  const splashEl = document.querySelector(".splash");
  if (typeof splashEl != "undefined" && splashEl != null) {
    //tl.pause();
    setTimeout(function () {
      document.querySelector(".textwrap p").classList.add("on");
      setTimeout(function () {
        splashTextDone();
      }, 500);
    }, 500);

    function splashTextDone() {
      let contactBlocks = document.querySelectorAll(".contacts");
      for (let i = 0; i < contactBlocks.length; ++i) {
        contactBlocks[i].classList.add("on");
      }
    }
  }

  // DIRECTOR LINKS
  const directorList = document.getElementById("director_list");
  const rsDirectorList = document.getElementById("rs_list");
  const smDirectorList = document.getElementById("shipmates_list");
  const directorFilter = directorList.querySelector("ul.filter");
  if (typeof directorFilter != "undefined" && directorFilter != null) {
    const directorFilterLinks = directorFilter.querySelectorAll("a");
  }
  const directorListItems = directorList.querySelectorAll(".director_item");
  const directorBg = document.getElementById("director_blue_bg");

  // 2023 addition of media reveal on director list hover

  function removeActiveMedia() {
    let mediaCells = document.querySelectorAll("#director_media .cell");
    mediaCells.forEach((mediaCell) => {
      mediaCell.classList.remove("active");
    });
  }

  let directorLinks = document.querySelectorAll("a.media_hover");
  directorLinks.forEach((directorLink) => {
    directorLink.addEventListener("mouseenter", function () {
      let directorId = directorLink.getAttribute("data-id");
      let targetMedia = document.querySelector(
        "#director_media .cell[data-id='" + directorId + "']"
      );
      let targetVideo = targetMedia.querySelector("video");
      if (typeof targetVideo != "undefined" && targetVideo != null) {
        if (targetVideo.classList.contains("sizeload")) {
          sizeloadVideo(targetVideo);
        }
        targetVideo.play();
      }
      removeActiveMedia();
      targetMedia.classList.add("active");
    });
  });

  let mainNavLinks = document.querySelectorAll("a.main_nav");
  mainNavLinks.forEach((mainNavLink) => {
    mainNavLink.addEventListener("mouseenter", function () {
      removeActiveMedia();
    });
  });

  // disable clicking parent Dropdown links
  let ddNavLinks = document.querySelectorAll("a.dd_trigger");
  ddNavLinks.forEach((ddNavLink) => {
    ddNavLink.addEventListener("click", function (e) {
      e.preventDefault();
      return;
    });
  });

  // when hovering out of the list area, close any open menus
  let ddListEls = document.querySelectorAll(".dd_list");
  ddListEls.forEach((ddListEl) => {
    ddListEl.addEventListener("mouseleave", function () {
      closeDirectors();
      closeRS();
      closeSM();
      removeActiveMedia();
      // remove fixed page text
      let pageTextFixedEl = document.querySelector(".pageText_fixed");
      if (typeof pageTextFixedEl != "undefined" && pageTextFixedEl != null) {
        pageTextFixedEl.classList.remove("ready");
        setTimeout(function () {
          pageTextFixedEl.parentNode.removeChild(pageTextFixedEl);
        }, 510);
      }
    });
  });

  let ddTriggers = document.querySelectorAll("header nav a.dd_trigger");

  // set actions for mouse over and mouse leave
  var hi = new SV.HoverIntent(ddTriggers, {
    // required parameters
    onEnter: function (targetItem) {
      toggleDirectors(targetItem);
    },
    onExit: function (targetItem) {
      //toggleDirectors(targetItem);
    },

    // default options
    exitDelay: 400,
    interval: 100,
    sensitivity: 7,
  });

  function removeCategoryActive() {
    directorFilterLinks.forEach((directorFilterLink) => {
      directorFilterLink.classList.remove("pageOn");
    });
  }

  /*
  // HANDLE DIRECTOR CATEGORY FILTERS
  directorFilterLinks.forEach(directorFilterLink => {
    directorFilterLink.addEventListener("click", function(e) {
      e.preventDefault();
      let theFilter = directorFilterLink.getAttribute("data-filter");
      removeCategoryActive();
      directorFilterLink.classList.add("pageOn");
      // loop through director items and find matching tags
      directorListItems.forEach(directorItem => {
        let directorTags = directorItem.getAttribute("data-filter");
        let filterCheck = directorTags.indexOf(theFilter);
        if (filterCheck >= 0) {
          directorItem.classList.remove("hide");
        } else {
          directorItem.classList.add("hide");
        }
      });
    });
  });
  */

  // TEXTPAGE LINKS FROM THE CMS OPEN UP OVERLAY WITH BLURRED BG
  let textLinks = document.querySelectorAll("a.overlay_trigger");
  let textLinksLength = textLinks.length;
  for (let i = 0; i < textLinksLength; ++i) {
    textLinks[i].addEventListener("click", function (e) {
      e.preventDefault();

      // remove on state form nav items
      let navListItems = nav.querySelectorAll("ul li a");
      navListItems.forEach((navListItem) => {
        navListItem.classList.remove("pageOn");
      });

      // asign on state to selected link
      this.classList.add("pageOn");

      let textSlug = this.getAttribute("data-slug");
      if (body.classList.contains("overlay_open")) {
        closeOverlay();
      } else {
        textOverlay(textSlug, this);
      }
    });
  }

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      if (body.classList.contains("menuOn")) {
        closeDirectors();
        closeRS();
        closeSM();
        closeOverlay();
        body.classList.remove("blur");
        body.classList.remove("menuOn");
        // remove the shipmates text
        let pageText = document.querySelector(".pageText_fixed");
        if (typeof pageText != "undefined" && pageText != null) {
          pageText.classList.remove("ready");
          setTimeout(function () {
            pageText.parentNode.removeChild(pageText);
          }, 300);
        }
      } else {
        resetNav();
        closeOverlay();
        //openDirectors();
        body.classList.remove("blur");
        body.classList.add("menuOn");
      }
    },
    true
  );

  //from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/after()/after().md
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty("after")) {
        return;
      }
      Object.defineProperty(item, "after", {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function after() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(
              isNode ? argItem : document.createTextNode(String(argItem))
            );
          });

          this.parentNode.insertBefore(docFrag, this.nextSibling);
        },
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

  // Scrolling Grid effect
  let scrollingCols = document.querySelector(".scrolling_columns");
  if (scrollingCols !== null && scrollingCols !== undefined) {
    const cols = gsap.utils.toArray(".col");

    //Duplicate images for loop
    cols.forEach((col, i) => {
      const contents = col.childNodes;

      contents.forEach((content, i) => {
        let clone = content.cloneNode(true);
        col.appendChild(clone);
        //col.appendChild(clone);
      });
    });

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });

    let scrollSpeed = 0.5;

    // Set odd number column animation
    let oddCols = document.querySelectorAll(".col:nth-child(odd)");

    oddCols.forEach((oddCol, i) => {
      let ImageSet = oddCol.querySelectorAll(".cell");
      if (ImageSet.length > 0) {
        let TL = verticalLoop(ImageSet, {
          paused: false,
          repeat: -1,
          reversed: false,
          speed: scrollSpeed,
          draggable: false,
        });
      }
    });

    //Set even number column animation
    let evenCols = document.querySelectorAll(".col:nth-child(even)");

    evenCols.forEach((evenCol, i) => {
      let EvenImageSet = evenCol.querySelectorAll(".cell");
      if (EvenImageSet.length > 0) {
        let evenTL = verticalLoop(EvenImageSet, {
          paused: false,
          repeat: -1,
          reversed: true,
          speed: scrollSpeed,
          draggable: false,
        });
      }
    });
  }

  function verticalLoop(items, config) {
    let timeline;
    items = gsap.utils.toArray(items);
    config = config || {};
    gsap.context(() => {
      let onChange = config.onChange,
        lastIndex = 0,
        tl = gsap.timeline({
          repeat: config.repeat,
          onUpdate:
            onChange &&
            function () {
              let i = tl.closestIndex();
              if (lastIndex !== i) {
                lastIndex = i;
                onChange(items[i], i);
              }
            },
          paused: config.paused,
          defaults: { ease: "none" },
          onReverseComplete: () =>
            tl.totalTime(tl.rawTime() + tl.duration() * 100),
        }),
        length = items.length,
        startY = items[0].offsetTop,
        times = [],
        heights = [],
        spaceBefore = [],
        yPercents = [],
        curIndex = 0,
        center = config.center,
        clone = (obj) => {
          let result = {},
            p;
          for (p in obj) {
            result[p] = obj[p];
          }
          return result;
        },
        pixelsPerSecond = (config.speed || 1) * 100,
        snap =
          config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        timeOffset = 0,
        container =
          center === true
            ? items[0].parentNode
            : gsap.utils.toArray(center)[0] || items[0].parentNode,
        totalHeight,
        getTotalHeight = () =>
          items[length - 1].offsetTop +
          (yPercents[length - 1] / 100) * heights[length - 1] -
          startY +
          spaceBefore[0] +
          items[length - 1].offsetHeight *
            gsap.getProperty(items[length - 1], "scaleY") +
          (parseFloat(config.paddingBottom) || 0),
        populateHeights = () => {
          let b1 = container.getBoundingClientRect(),
            b2;
          startY = items[0].offsetTop;
          items.forEach((el, i) => {
            heights[i] = parseFloat(gsap.getProperty(el, "height", "px"));
            yPercents[i] = snap(
              (parseFloat(gsap.getProperty(el, "y", "px")) / heights[i]) * 100 +
                gsap.getProperty(el, "yPercent")
            );
            b2 = el.getBoundingClientRect();
            spaceBefore[i] = b2.top - (i ? b1.bottom : b1.top);
            b1 = b2;
          });
          gsap.set(items, {
            // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
            yPercent: (i) => yPercents[i],
          });
          totalHeight = getTotalHeight();
        },
        timeWrap,
        populateOffsets = () => {
          timeOffset = center
            ? (tl.duration() * (container.offsetWidth / 2)) / totalHeight
            : 0;
          center &&
            times.forEach((t, i) => {
              times[i] = timeWrap(
                tl.labels["label" + i] +
                  (tl.duration() * heights[i]) / 2 / totalHeight -
                  timeOffset
              );
            });
        },
        getClosest = (values, value, wrap) => {
          let i = values.length,
            closest = 1e10,
            index = 0,
            d;
          while (i--) {
            d = Math.abs(values[i] - value);
            if (d > wrap / 2) {
              d = wrap - d;
            }
            if (d < closest) {
              closest = d;
              index = i;
            }
          }
          return index;
        },
        populateTimeline = () => {
          let i, item, curY, distanceToStart, distanceToLoop;
          tl.clear();
          for (i = 0; i < length; i++) {
            item = items[i];
            curY = (yPercents[i] / 100) * heights[i];
            distanceToStart = item.offsetTop + curY - startY + spaceBefore[0];
            distanceToLoop =
              distanceToStart + heights[i] * gsap.getProperty(item, "scaleY");
            tl.to(
              item,
              {
                yPercent: snap(((curY - distanceToLoop) / heights[i]) * 100),
                duration: distanceToLoop / pixelsPerSecond,
              },
              0
            )
              .fromTo(
                item,
                {
                  yPercent: snap(
                    ((curY - distanceToLoop + totalHeight) / heights[i]) * 100
                  ),
                },
                {
                  yPercent: yPercents[i],
                  duration:
                    (curY - distanceToLoop + totalHeight - curY) /
                    pixelsPerSecond,
                  immediateRender: false,
                },
                distanceToLoop / pixelsPerSecond
              )
              .add("label" + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
          }
          timeWrap = gsap.utils.wrap(0, tl.duration());
        },
        customAnimations = () => {
          let { enterAnimation, leaveAnimation } = config,
            eachDuration = tl.duration() / items.length;
          items.forEach((item, i) => {
            let anim = enterAnimation && enterAnimation(item, eachDuration, i),
              isAtEnd =
                anim &&
                tl.duration() -
                  timeWrap(times[i] - Math.min(eachDuration, anim.duration())) <
                  eachDuration - 0.05;
            anim &&
              tl.add(anim, isAtEnd ? 0 : timeWrap(times[i] - anim.duration()));
            anim = leaveAnimation && leaveAnimation(item, eachDuration, i);
            isAtEnd = times[i] === tl.duration();
            anim &&
              anim.duration() > eachDuration &&
              anim.duration(eachDuration);
            anim && tl.add(anim, isAtEnd ? 0 : times[i]);
          });
        },
        refresh = (deep) => {
          let progress = tl.progress();
          tl.progress(0, true);
          populateHeights();
          deep && populateTimeline();
          populateOffsets();
          customAnimations();
          deep && tl.draggable
            ? tl.time(times[curIndex], true)
            : tl.progress(progress, true);
        },
        onResize = () => refresh(true),
        proxy;
      gsap.set(items, { y: 0 });
      populateHeights();
      populateTimeline();
      populateOffsets();
      customAnimations();
      window.addEventListener("resize", onResize);
      function toIndex(index, vars) {
        vars = clone(vars);
        Math.abs(index - curIndex) > length / 2 &&
          (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
          time = times[newIndex];
        if (time > tl.time() !== index > curIndex) {
          // if we're wrapping the timeline's playhead, make the proper adjustments
          time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        if (vars.revolutions) {
          time += tl.duration() * Math.round(vars.revolutions);
          delete vars.revolutions;
        }
        if (time < 0 || time > tl.duration()) {
          vars.modifiers = { time: timeWrap };
        }
        curIndex = newIndex;
        vars.overwrite = true;
        gsap.killTweensOf(proxy);
        return tl.tweenTo(time, vars);
      }
      tl.elements = items;
      tl.next = (vars) => toIndex(curIndex + 1, vars);
      tl.previous = (vars) => toIndex(curIndex - 1, vars);
      tl.current = () => curIndex;
      tl.toIndex = (index, vars) => toIndex(index, vars);
      tl.closestIndex = (setCurrent) => {
        let index = getClosest(times, tl.time(), tl.duration());
        setCurrent && (curIndex = index);
        return index;
      };
      tl.times = times;
      tl.progress(1, true).progress(0, true); // pre-render for performance
      if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
      }
      if (config.draggable && typeof Draggable === "function") {
        proxy = document.createElement("div");
        let wrap = gsap.utils.wrap(0, 1),
          ratio,
          startProgress,
          draggable,
          dragSnap,
          align = () =>
            tl.progress(
              wrap(startProgress + (draggable.startY - draggable.y) * ratio)
            ),
          syncIndex = () => tl.closestIndex(true);
        typeof InertiaPlugin === "undefined" &&
          console.warn(
            "InertiaPlugin required for momentum-based scrolling and snapping. https://gsap.com/pricing"
          );
        draggable = Draggable.create(proxy, {
          trigger: items[0].parentNode,
          type: "y",
          onPressInit() {
            gsap.killTweensOf(tl);
            startProgress = tl.progress();
            refresh();
            ratio = 1 / totalHeight;
            gsap.set(proxy, { y: startProgress / -ratio });
          },
          onDrag: align,
          onThrowUpdate: align,
          inertia: true,
          snap: (value) => {
            let time = -(value * ratio) * tl.duration(),
              wrappedTime = timeWrap(time),
              snapTime = times[getClosest(times, wrappedTime, tl.duration())],
              dif = snapTime - wrappedTime;
            Math.abs(dif) > tl.duration() / 2 &&
              (dif += dif < 0 ? tl.duration() : -tl.duration());
            return (time + dif) / tl.duration() / -ratio;
          },
          onRelease: syncIndex,
          onThrowComplete: syncIndex,
        })[0];
        tl.draggable = draggable;
      }
      tl.closestIndex(true);
      onChange && onChange(items[curIndex], curIndex);
      timeline = tl;
      return () => window.removeEventListener("resize", onResize); // cleanup
    });
    return timeline;
  }
});
